export default __webpack_public_path__ + "static/media/couponicon.160d1900.svg";